import { Table } from 'tiptap-extensions';
import { selectTable } from 'prosemirror-utils';
import { tableEditing, columnResizing } from 'prosemirror-tables';
import TableNodes from './table-nodes';

export default class TableNode extends Table {
  options = {
    resizable: false,
    resizeOptions: {},
  };

  constructor(options: {
    resizable?: boolean;
    resizeOptions?: {
      handleWidth?: number;
      cellMinWidth?: number;
      lastColumnResizable?: boolean;
    };
  }) {
    super(options);

    this.options = {
      ...this.options,
      ...options,
    };
  }

  get schema() {
    return TableNodes.table;
  }

  keys() {
    return {
      ...this.keys,
      'Mod-a': (state, dispatch) => {
        dispatch(selectTable(state.tr));
        return true;
      },
    };
  }

  get plugins() {
    return [
      ...(this.options.resizable ? [columnResizing(this.options.resizeOptions)] : []),
      tableEditing(),
    ];
  }
}
